import type { SvgType } from './types'

export default function RoundedSquare({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={size} height={size} rx={2} fill={fill} />
    </svg>
  )
}
